import LoadEventList from '@/brain/quote/load-event-list/LoadEventList'
import SaveQuotationRequest from '@/brain/quote/save-quotation-request'
import SaveQuotationResponse from '@/brain/quote/save-quotation-response'

const state = {
  list: [],
  suppliers: {}
}

const getters = {
  ALL_ITEMS: state => state.list,
  ALL_SUPPLIERS: state => {
    const sortedId = Object.keys(state.suppliers).sort((a, b) => state.suppliers[b].total - state.suppliers[a].total)
    const sortedSuppliers = {}
    for (const id of sortedId) {
      sortedSuppliers[id] = state.suppliers[id]
    }
    return sortedSuppliers
  },
  ITEM_BY_ID: state => itemId => state.list.find(i => i._id === itemId),
  SUPPLIER_BY_ID: state => supplierId => state.suppliers[supplierId]
}

const mutations = {
  SET_LIST_ITEMS: (state, { listItems }) => { state.list = listItems },
  SET_SUPPLIERS: (state, suppliers) => { state.suppliers = suppliers },
  ADD_QUOTATION: (state, { itemId, supplierId }) => {
    const suppliers = { ...state.suppliers }
    suppliers[supplierId].itemsQuoted.push(itemId)
    state.suppliers = suppliers
  },
  REMOVE_QUOTATION: (state, { itemId, supplierId }) => {
    const suppliers = { ...state.suppliers }
    const arrPosition = suppliers[supplierId].itemsQuoted.indexOf(itemId)
    suppliers[supplierId].itemsQuoted.splice(arrPosition, 1)
    state.suppliers = suppliers
  },
  UPDATE_QUOTATION_RESPONSE_ITEM: (state, {
    supplierId,
    quoteId,
    productName,
    productLab,
    productId,
    isPriceGuaranted,
    cmedPrice,
    notQuote,
    price
    }) => {
    const priceFlat = price
      .toString()
      .replace('.', '')
      .replace(',', '.')

    const priceNoZero = Number(priceFlat)

    const quoteIdx = state.list.findIndex(i => i && i._id.toString() === quoteId.toString())
    const suppliersQuote = state.list[quoteIdx].suppliersQuote.quotations.findIndex(i => i.supplier.toString() === supplierId.toString())
    const resetProductName = productName.replace(/\s-\s.+/gi, '')
    const newItemQuoted = {
      ...state.list[quoteIdx].suppliersQuote.quotations[suppliersQuote],
      comercialName: resetProductName,
      isPriceGuaranted,
      item: productId,
      lab: productLab,
      cmedPrice,
      notQuote,
      price: priceNoZero
    }
    state.list[quoteIdx].suppliersQuote.quotations[suppliersQuote] = newItemQuoted
  }
}

const actions = {
  LOAD_EVENT_LIST: LoadEventList,
  SAVE_QUOTATION_REQUEST: SaveQuotationRequest,
  SAVE_QUOTATION_RESPONSE: SaveQuotationResponse
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/item-quote/state/index.js